import { takeLatest, put } from 'redux-saga/effects';

import {
  NEW_CONTROLE_PRAGA_DOENCA,
  NEW_CONTROLE_PRAGA_DOENCA_SUCCESS,
} from '../actionTypes';

import { controlePragaDoenca } from '../entity';

function* sagaNewControlePragaDoenca() {
  yield put({ type: NEW_CONTROLE_PRAGA_DOENCA_SUCCESS, registro: controlePragaDoenca.newRegistro })
}

export default function* watchNewControlePragaDoenca() {
  yield takeLatest(NEW_CONTROLE_PRAGA_DOENCA, sagaNewControlePragaDoenca)
}
